
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import TestimonialCard from '@/components/TestimonialCard';

const TestimonialsSection = () => {
  return (
    <section className="section">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Wat onze klanten over ons zeggen</h2>
          <p className="section-subtitle mx-auto">
            Hoor het van de bedrijfsleiders die met ons samenwerken.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <TestimonialCard 
            author="Werner Temmerman" 
            role="Sales Director Belgium" 
            company="Penneo" 
            quote="We hebben ons marktaandeel vergroot en ons vermogen om deals te sluiten is in korte tijd aanzienlijk verbeterd." 
          />
          <TestimonialCard 
            author="Frank Prinsen" 
            role="Manager klantrelaties Politie en veiligheidsdiensten" 
            company="Cipal Schaubroeck" 
            quote="Afsprakenmaker maakt het onmogelijke mogelijk en heeft onze best practices voor lead- en dealgeneratie volledig getransformeerd." 
          />
          <TestimonialCard 
            author="Lode Uytterschaut" 
            role="Founder & CEO" 
            company="Start it X @KBC" 
            quote="Hun innovatieve mogelijkheden op gebied van data-intelligentie hebben ons leadgeneratieproces naar zelfs de grootste bedrijven drastisch vereenvoudigd." 
          />
        </div>
        
        <div className="mt-10 text-center">
          <Link to="/leadgeneratie-kmo" className="btn-outline inline-flex items-center gap-2">
            Meer succesverhalen
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
